import React from "react";

import { Text, Grid, Image } from "atoms";
import NoDataIcon from "assets/img/no-data.png";

export const NoData = () => {
  return (
    <Grid placeItems="center" height="24rem">
      <Image src={NoDataIcon} alt="No Data" height="17rem" width="20rem" />
      <Text color="neutral.500" fontSize="2.4rem" fontFamily="NeometricBold" mt="1.8rem">
        No Data
      </Text>
    </Grid>
  );
};
